import Case from 'case';

export default function AttrsTranslateFilter(gettextCatalog, gettext) {
  'ngInject';

  const conversionDict = {
    generator_model: gettext('Generator Model'),
    po: gettext('PO'),
    year: gettext('Year'),
    'model year': gettext('Model Year'),
    vin: gettext('VIN'),
    make: gettext('Make'),
    model: gettext('Model'),
    'onei3:serial': gettext('Onei3 Serial'),
    'onei3:model': gettext('Onei3 Model'),
  };

  return function (input) {
    if (!input) return '';

    const conversion = conversionDict[input.toLowerCase()];
    if (!conversion) {
      return Case.title(input);
    }

    return gettextCatalog.getString(conversion);
  };
}
